<template>
  <div>
    <div v-if="!Boolean(diaryDataTimeFilter.length)" class="non-trainings">
      {{ $t('courseReport.emptyReport') }}
    </div>
    <div v-else class="scroll-table scroll-table-min">
      <table class="table table-list-training min">
        <thead id="general">
          <tr>
            <th class="th-mid">{{ $t('general.date') }}</th>
            <th class="th-mid">{{ $t('courseReport.dyspnea') }} <br />{{ $tc('courseReport.atRest', 2) }}</th>
            <th class="th-mid">
              {{ $t('courseReport.dyspnea') }} <br />{{ $tc('courseReport.withexertion', 2) }}
            </th>
            <th class="th-mid">{{ $t('courseReport.pain') }} <br />{{ $t('courseReport.heart') }}</th>
            <th class="th-mid">
              {{ $t('courseReport.pain') }} <br />
              {{ $t('courseReport.chest') }}
            </th>
            <th class="th-small">{{ $t('courseReport.weight') }}</th>
            <th>{{ $t('courseReport.comment') }}</th>
          </tr>
        </thead>
        <tbody>
          <diary-table-row
            v-for="diary in diaryDataTimeFilter"
            :key="diary.id"
            :diaryData="diary"
          ></diary-table-row>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/mixins/format-date.js'
import { timePeriods } from '@/main.config'
import DiaryTableRow from '@/components/table-rows/DiaryTableRow.vue'

export default {
  name: 'DiaryTable',
  mixins: [formatDate],
  components: {
    DiaryTableRow
  },
  props: {
    diaryData: {
      type: Array,
      required: true
    },
    activeTimeData: {
      type: Number,
      required: true
    },
    selectedDate: {
      type: Date,
      required: false
    }
  },
  computed: {
    diaryDataTimeFilter() {
      return this.getDataWithTimeFilter(this.diaryData)
    }
  },
  watch: {},
  methods: {
    getDataWithTimeFilter(diaryData) {
      const currentDate = new Date()
      let timeDataStartDate
      let timeDataEndDate = currentDate
      switch (this.activeTimeData) {
        case timePeriods.allTime:
          return diaryData
        case timePeriods.oneDay:
          timeDataStartDate = this.selectedDate
          timeDataEndDate = new Date(
            this.selectedDate.getFullYear(),
            this.selectedDate.getMonth(),
            this.selectedDate.getDate() + 1
          )
          break
        case timePeriods.oneWeek:
          timeDataStartDate = new Date(
            this.selectedDate.getFullYear(),
            this.selectedDate.getMonth(),
            this.selectedDate.getDate() - 6
          )
          timeDataEndDate = new Date(
            this.selectedDate.getFullYear(),
            this.selectedDate.getMonth(),
            this.selectedDate.getDate() + 1
          )
          break
        case timePeriods.oneMonth:
          timeDataStartDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate() - 31
          )
          break
        case timePeriods.threeMonths:
          timeDataStartDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate() - 92
          )
          break
      }
      const filteredArray = diaryData.filter(item => {
        const itemDate = new Date(item.createdAt)
        return itemDate >= timeDataStartDate && itemDate <= timeDataEndDate
      })

      return filteredArray
    }
  }
}
</script>

<style>
.is-dyspnea {
  height: calc(100% - 30px);
}
</style>
